export const WAFFLE_MENU_ACTIVE_APP_ID = 'shop';
export const CUSTOMER_CARE_HELPER_TEXT = 'Search by customer or order';
export const CUSTOMER_CARE_LABEL = 'Cat Customer Care Home';
export const TRANSACT_GUEST_HELPER_TEXT =
  'Transact on behalf of a guest customer';
export const TRANSACT_GUEST_LABEL = 'Transact As Guest';
export const TRANSACT_GUEST_REDIRECT = 'transactAsAGuest';

export const SHOW_MANUAL_APPROVAL = 'showManualApproval';
export const DIAGRAMS = 'diagrams';
